import { ProjectStatus } from "models/ProjectStatus";

interface ProjectData {
  id: number;
  name: string;
  user_owner_id: number;
  project_status: ProjectStatus;
  last_request_timestamp: string;
  created_timestamp: string;
  updated_timestamp: string;
}

export const ProjectDataPlaceholder: ProjectData = {
  id: -1,
  name: "",
  user_owner_id: 0,
  project_status: ProjectStatus.intiailising,
  last_request_timestamp: "",
  created_timestamp: "",
  updated_timestamp: "",
};

export default ProjectData;
